// components
import { PersonalComponent } from './personal.component';
import { CreateQuestComponent } from './create-quest/create.dialog.component';

export const PERSONAL_COMPONENTS: any[] = [
  PersonalComponent,
  CreateQuestComponent,
];

// services



// WEBPACK FOOTER //
// ./src/app/components/dashboard/personal/index.ts